/**
 * English copy for statement PDFs, keep in sync with Dashboard.Statements.TaxPackPrint in i18n.
 * Backend handover: reuse these strings when implementing server-side PDF generation.
 */
export const TAX_PACK_PDF_COPY = {
  documentTitle: 'Gift Aid donation summary',
  swiftaidStatementTitle: 'Annual Swiftaid statement',
  swiftaidGiftAidedDonations: 'Gift Aided donations',
  swiftaidMaximumGiftAid: 'Maximum Gift Aid',
  itemisedHeading: 'All donations',
  combinedTotalGiftAid: 'Total Gift Aid',
  addedByYouTitle: 'Added by you',
  totalDonated: 'Total donated',
  giftAid: 'Gift Aid',
  donorSection: 'Donor details',
  statementSection: 'Statement details',
  donorIntermediary: 'Intermediary',
  issued: 'Issued date',
  intermediaryName: 'Streeva Ltd',
  refNo: 'Statement reference',
  noDonationsInYear:
    'No donations were recorded for this tax year. If you gave during this period, they may still be processing or were made outside Swiftaid.',
  taxResponsibility:
    'If you paid less income tax and capital gains tax this year than the Gift Aid claimed on all your donations, you must pay any difference.',
  addedByYouIntro:
    'These donations were added by you for your own records. They have not been verified, processed, or submitted for Gift Aid by Swiftaid.',
  tableCharity: 'Charity',
  tableDate: 'Date',
  tableAmount: 'Amount',
  tableGiftAid: 'Gift Aid',
  giftAidNa: '—',
  sourceAddedByYou: 'Added by you',
  brandFooter: 'Swiftaid · Gift Aid made easy',
} as const
